// Sonar/client/ui/AlertsView.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class AlertsView extends ComponentBase {
    constructor(config) {
        super(config);
        this.dataView = null;
    }

    async initialize() {
        this.dataView = await this.createManagedComponent("DataCrud", null, {
            instanceId: "sonar-alerts-view",
            rpcClass: "AlertRpc",
            schemaPath: "collections/alerts",
            title: "My Alerts",
            viewConfig: {
                mode: 'list',
                toolbar: { create: { enabled: false } }, // Users cannot create alerts
                fields: [
                    { name: 'title', label: 'Alert', render: (val) => `<strong>${val}</strong>` },
                    { name: 'content', label: 'Details', render: (val) => val.substring(0, 120) + '...' },
                    { name: 'sourceUrl', label: 'Source', render: (val) => val ? `<a href="${val}" target="_blank" rel="noopener noreferrer">View Source</a>` : 'N/A' },
                    { name: 'createdAt', label: 'Date', render: (val) => new Date(val).toLocaleString() }
                ],
                actions: [] // No actions for alerts in this view
            },
            dataConfig: {
                autoLoad: false,
                sort: { createdAt: -1 } // Show newest alerts first
            }
        });
        await super.initialize();
    }

    async initAfterLogin() {
        if (this.dataView) {
            this.dataView.refreshData();
        }
    }

    async render() {
        return await this.dataView.render();
    }
}